import { Input, InputField, VStack } from "@gluestack-ui/themed";
import { EmergencyWithdrawConfirmController } from "./controller";
import { Text } from "@repo/core/components/core/Text";
import { Icon } from "@repo/core/components/core/Icon";
import { Button } from "@repo/core/components/core/Button";
import { AlertModal } from "@repo/core/components/layout/ModalTemplate/AlertModal";
import { AlertModalVariant } from "@repo/core/components/layout/ModalTemplate/AlertModal/types";
import { formatDateTimeString } from "@repo/core/utils/date.utils";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const EmergencyWithdrawConfirm = () => {
  const {
    isMobile,
    isMobileDevice,
    back,
    handleConfirmCardCvv,
    alertModalRef,
    alertOptions
  } = EmergencyWithdrawConfirmController();
  return (
    <>
      <Scaffolds.Root
        title="Saque Emergencial"
        statusBarVariant={StatusBarVariantEnum.LIGHT}
      >
        <Scaffolds.Form
          footerContent={
            <VStack
              flex={1}
              w="$full"
              gap="$4"
              pb={isMobile ? "$4" : "$12"}
              px="$4"
              pt="$4"
              justifyContent="flex-end"
            >
              <Button
                text="Cancelar"
                action="negative"
                variant="outline"
                onPress={back}
              />
            </VStack>
          }
        >
          <VStack alignItems="center" pt="$24">
            <VStack mb="$4">
              <Icon name="lock" size={40} color="$primary600" />
            </VStack>
            <Text mb="$6" fontSize="$lg" fontWeight={600} color="$textLight900">
              Senha
            </Text>
            <VStack
              maxWidth={230}
              mb="$10"
              alignItems="center"
              justifyContent="center"
            >
              <Text
                fontSize="$sm"
                fontWeight={400}
                color="$textLight900"
                textAlign="center"
              >
                Digite a senha do cartão:
              </Text>
            </VStack>
            <Input h="$16" w={130} alignItems="center" bg="$backgroundLight50">
              <InputField
                h="$full"
                w="$full"
                pl={isMobileDevice ? "$0" : "auto"}
                pr="$0"
                bg="$backgroundLight50"
                borderRadius={8}
                borderWidth="$1"
                borderColor="$backgroundLight400"
                color="$backgroundLight400"
                fontSize="$5xl"
                secureTextEntry
                textAlign="center"
                letterSpacing={12}
                maxLength={4}
                placeholder="••••"
                onSubmitEditing={handleConfirmCardCvv}
                onKeyPress={(e) => {
                  // NOTE: When pressed Enter on web
                  if (e.keyCode === 13) {
                    handleConfirmCardCvv();
                  }
                }}
              />
            </Input>
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.Root>
      <AlertModal
        ref={alertModalRef}
        title="Transação realizada"
        variant={AlertModalVariant.success}
        options={alertOptions}
      >
        <VStack gap={4} alignItems="center">
          <Text>MOBLY</Text>
          <Text fontWeight={600}>{numberToBrl(1250)}</Text>
          <Text fontSize="$sm">{formatDateTimeString(new Date())}</Text>
        </VStack>
      </AlertModal>
    </>
  );
};
export default EmergencyWithdrawConfirm;
